<template>
  <div>
    <h4 class="mt-6">Embedding</h4>
    <span>Select the form of embedding to be used on the websites.</span>

    <vs-row class="mb-8">
      <vx-card class="max-w-sm mt-4 mr-6">
        <b>Booking implementation code</b><br />
        <span>Select how the booking form should be loaded</span>
        <vs-row class="mt-3" vs-justify="center">
          <vs-button
            @click="
              codePopupText = previewCodes.bookingButton;
              codePopupActive = true;
            "
            class="w-full mb-2"
            >Booking button</vs-button
          >
          <vs-button
            @click="
              codePopupText = previewCodes.bookingLink;
              codePopupActive = true;
            "
            class="w-full mb-2"
            >Booking link</vs-button
          >
        </vs-row>
      </vx-card>
      <vx-card class="max-w-sm mt-4">
        <b>Guest list implementation code</b><br />
        <span>Select how the guest list form should be loaded</span>
        <vs-row class="mt-3" vs-justify="center">
          <vs-button
            @click="
              codePopupText = previewCodes.guestListButton;
              codePopupActive = true;
            "
            class="w-full mb-2"
            >Guest list button</vs-button
          >
          <vs-button
            @click="
              codePopupText = previewCodes.guestListLink;
              codePopupActive = true;
            "
            class="w-full mb-2"
            >Guest list link</vs-button
          >
        </vs-row>
      </vx-card>
    </vs-row>

    <vs-popup style="z-index: 999123" :active.sync="codePopupActive" title="Embed code">
      <p class="pb-2">Copy and paste the following code to embed the form</p>
      <vs-textarea readonly v-model="codePopupText"></vs-textarea>
    </vs-popup>
  </div>
</template>

<script>
import * as _ from "lodash";

import { mapGetters } from "vuex";

export default {
  props: {
    venueDetails: Object,
  },
  components: {},
  data() {
    return {
      codePopupActive: false,
      codePopupText: "",
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
    }),
    previewCodes() {
      return {
        bookingButton: `<button onclick="rekomLoadBookingForm('${this.activeVenueDetails.shortName}')">Booking button</button>`,
        bookingLink: `<a href="javascript:rekomLoadBookingForm('${this.activeVenueDetails.shortName}')">Booking link</a>`,
        guestListButton: `<button onclick="rekomLoadGuestListForm('${this.activeVenueDetails.shortName}')">Guest list button</button>`,
        guestListLink: `<a href="javascript:rekomLostGuestListForm('${this.activeVenueDetails.shortName}')">Guest list link</a>`,
      };
    },
  },
  async mounted() {},

  methods: {},
};
</script>